export const fee_lange={
    TH:{
        fee_data:"จัดการข้อมูลค่าธรรมเนียม",
        add_fee:"เพิ่มข้อมูลค่าธรรมเนียม",
        fee_id:"รหัสค่าธรรมเนียม",
        fee_description:"รายละเอียดค่าธรรมเนียม",
        fee_date:"วันที่ต้องชำระ (ล่าสุด)",
        fee_type:"ชนิดค่าธรรมเนียม",
        fee_price:"ราคา",
        edit:"แก้ไข",
        delete:"ยกเลิกค่าธรรมเนียม",
        back_to_fee_data:"กลับไปหน้าแสดงข้อมูลค่าธรรมเนียม",
        alert_fee_description:"กรุณากรอกรายละเอียดค่าธรรมเนียม",
        alert_fee_date:"กรุณาเลือกวันที่",
        fee_date_error:"กรุณากเลือกวันที่ให้ถูกต้อง",
        alert_fee_type:"กรุณาเลือกชนิดของค่าธรรมเนียม",
        alert_fee_price:"กรุณากรอกราคา",
        fee_price_error:"กรุณากรอกราคาให้ถูกต้อง",
        save_data:"บันทึกข้อมูล",
        no_internet:"เกิดข้อผิดพลาดในการดึงข้อมูล กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตของคุณ!",
        saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!" ,
        confirm_delete:"คุณต้องการยกเลิกข้อมูลนี้ใช่หรือไม่?"  ,
        warning_delete:"ข้อมูลยกเลิกแล้วไม่สามารถย้อนกลับได้!",
        want_delete:"ฉันต้องการยกเลิก",
        close:"ปิดหน้านี้" ,
        deleted:"ข้อมูลถูกยกเลิกเรียบร้อยแล้ว!",
        search:"ค้นหา",
        place_id:"รหัสที่อยู่",
        customer_name:"ชื่อ-สกุลลูกค้า",
        fee_count:"จำนวน(ครั้ง)",
        customer_error:"กรุณาเลือกผู้เสียค่าธรรมเนียม",
        fee_count_error:"กรุณากรอกจำนวนให้ถูกต้อง",
        customer_place:"สถานที่",
        gen_type:"ประเภทรอบที่ต้องชำระ",
        alert_gen_type:"กรุณาเลือกประเภทรอบการชำระ",
        gen_type_time01:"เวลาที่ออกใบแจ้งหนี้",
        gen_type_time02:"วันที่ออกใบแจ้งหนี้",
        gen_type_time03:"วันที่ที่ออกใบแจ้งหนี้",
        gen_type_time04:"เดือนที่ออกใบแจ้งหนี้",
        place_alert:"กรุณาเลือกสถานที่ลูกค้า",
        alert_gen_type01:"กรุณาเลือกเวลาที่ออกใบแจ้งหนี้",
        alert_gen_type02:"กรุณาเลือกวันที่ออกใบแจ้งหนี้",
        alert_gen_type03:"กรุณาเลือกวันที่ออกใบแจ้งหนี้",
        alert_gen_type04:"กรุณาเลือกเดือนที่ออกใบแจ้งหนี้",
        request_general_id:"หมายเลขคำร้อง",
        request_alert:"กรุณากรอกหมายเลขคำร้อง",
        cancel_bill:"ยกเลิกใบเสร็จรับเงิน",
        service_price: 'ค่าบริการ',
        service_price_error: 'กรุณากรอกค่าบริการ'
    },
    EN:{
        fee_data:"Fee data",
        add_fee:"Add Fee Data",
        fee_id:"Fee ID",
        fee_description:"Fee description",
        fee_date:"Due date (last time)",
        fee_type:"Fee type",
        fee_price:"Price",
        edit:"Edit",
        place_id:"Place ID",
        delete:"Delete",
        back_to_fee_data:"Back to fee data",
        alert_fee_description:"please input fee description",
        alert_fee_date:"please pick a date",
        fee_date_error:"please pick date correctly",
        alert_fee_type:"please choose fee type",
        alert_fee_price:"please input fee price",
        fee_price_error:"please input fee price correctly",
        save_data:"save data",
        no_internet:"something wrong please check your connection",
        saved:"data was saved!" ,
        confirm_delete:"Are you sure to delete this data?"  ,
        warning_delelte:"Deleted data can't recovery!",
        want_delete:"Delete this data",
        close:"Close this page",
        deleted:"data was deleted!",
        search:"search",
        customer_name:"Customer name",
        fee_count:"Fee count(times)",
        customer_error:"please choose customer",
        fee_count_error:"please input fee count correctly",
        customer_place:"customer place",
        gen_type:"generate invoice type",
        alert_gen_type:"please input generate invoice type",
        gen_type_time01:"Time",
        gen_type_time02:"Date of week",
        gen_type_time03:"Date",
        gen_type_time04:"Month",
        place_alert:"please choose customer's place",
        alert_gen_type01:"please select time",
        alert_gen_type02:"please select date of week",
        alert_gen_type03:"please select date",
        alert_gen_type04:"please select month",
        request_general_id:"request general id",
        request_alert:"please input request general id",
        cancel_bill:"Cancel",
        service_price: 'service price',
        service_price_error: 'please input service price',
    }
}
